import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { AgFinancingInput, FieldMonitoringStatus } from '@indigo-ag/schema';

import { FieldMonitoringUtil } from 'shared';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { upsertFinancingAgFinancing } from 'features/brazil-grower/queries';
import { ToggleOnHold } from '../../ToggleOnHold/ToggleOnHold';

export const ToggleOnHoldFieldMonitoringAnalysis: React.FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinance } = useContext(FinanceProcessContext);

  /**
   * State
   */
  const [isAnalysisOnHold, setIsAnalysisOnHold] = useState(
    agFinance?.phase2?.fieldMonitoring?.status === FieldMonitoringStatus.ON_HOLD
  );

  /**
   * Mutations
   */
  const [upsertFinancingAgFinancingFn] = useMutation(upsertFinancingAgFinancing);

  const toggleOnHoldCreditAnalysis = (decisionNotes: string) => {
    const newAgFinancingData: Partial<AgFinancingInput> = {
      id: agFinance?.id,
      phase2: {
        fieldMonitoring: {
          status: FieldMonitoringUtil.isOnHold(agFinance?.phase2?.fieldMonitoring?.status)
            ? FieldMonitoringStatus.IN_PROGRESS
            : FieldMonitoringStatus.ON_HOLD,
          decisionNotes: decisionNotes
        }
      }
    };

    return upsertFinancingAgFinancingFn({
      variables: {
        data: newAgFinancingData
      }
    }).then(() => setIsAnalysisOnHold(!isAnalysisOnHold));
  };

  return (
    <ToggleOnHold
      visible={FieldMonitoringUtil.canOnHoldResume(agFinance?.phase2)}
      isOnHold={isAnalysisOnHold}
      onConfirmation={toggleOnHoldCreditAnalysis}
    />
  );
};
